import React from 'react';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import BasicButton from '../../Components/Button_Basic';
import BasicCombo from '../../Components/Combo_Basic';
import BasicModal from '../../Components/Modal_Basic';
import Checking from '../../Components/Checking';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import agCheckbox from '../../Components/agGrid/ag-Checkbox';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function Bm10060(props) {
    const gridRef = React.useRef();
    const gridRef1 = React.useRef();
    //왼쪽 그리드 컬럼
    const columnDefs = [
        {
            field: 'lcategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Lcategory' && f.lanType === 'COL')[0].lanName
                    : '', //대분류
            minWidth: 130,
        },
        {
            field: 'mcategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Mcategory' && f.lanType === 'COL')[0].lanName
                    : '', //중분류
        },
        {
            field: 'scategoCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_Scategory' && f.lanType === 'COL')[0].lanName
                    : '', //소분류
        },
        {
            field: 'lanName',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_LanName' && f.lanType === 'COL')[0].lanName
                    : '', //명칭
            minWidth: 130,
            editable: true,
        },
        {
            field: 'screenType',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ScreenType' && f.lanType === 'COL')[0].lanName
                    : '', //화면분류
            minWidth: 100,
        },
    ];
    //오른쪽 그리드 컬럼
    const columnDefs1 = [
        {
            field: 'detailCd',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DetailCd' && f.lanType === 'COL')[0].lanName
                    : '', //상세권한
            minWidth: 110,
        },
        {
            field: 'detailNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DetailNm' && f.lanType === 'COL')[0].lanName
                    : '', //상세권한참조
            minWidth: 130,
        },
        {
            field: 'createYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateYn' && f.lanType === 'COL')[0].lanName
                    : '', //추가권한
            minWidth: 110,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return null;
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'readYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ReadYn' && f.lanType === 'COL')[0].lanName
                    : '', //조회권한
            minWidth: 110,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return null;
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'updateYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateYn' && f.lanType === 'COL')[0].lanName
                    : '', //수정권한
            minWidth: 110,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return null;
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'deleteYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_DeleteYn' && f.lanType === 'COL')[0].lanName
                    : '', //삭제권한
            minWidth: 110,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return null;
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        {
            field: 'printYn',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_PrintYn' && f.lanType === 'COL')[0].lanName
                    : '', //출력권한
            minWidth: 110,
            cellRenderer: (e) => {
                if (e.value === 'X') {
                    return null;
                } else {
                    return agCheckbox(e);
                }
            },
            editable: false,
        },
        // {
        //   field: "excelYn",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_ExcelYn" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //EXCEL권한
        //   minWidth: 110,
        //   cellRenderer: (e) => {
        //     if (e.value === "X") {
        //       return null;
        //     } else {
        //       return agCheckbox(e);
        //     }
        //   },
        //   editable: false,
        // },
        // {
        //   field: "pdfYn",
        //   headerName:
        //     props.lanData.length > 0
        //       ? props.lanData.filter(
        //           (f) => f.lanId === "Col_PDAYn" && f.lanType === "COL"
        //         )[0].lanName
        //       : "", //PDF권한
        //   minWidth: 110,
        //   cellRenderer: (e) => {
        //     if (e.value === "X") {
        //       return null;
        //     } else {
        //       return agCheckbox(e);
        //     }
        //   },
        //   editable: false,
        // },
        {
            field: 'createDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateDate' && f.lanType === 'COL')[0].lanName
                    : '', //생성일자
        },
        {
            field: 'createId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CreateId' && f.lanType === 'COL')[0].lanName
                    : '', //생성자
        },
        {
            field: 'updateDate',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateDate' && f.lanType === 'COL')[0].lanName
                    : '', //수정일자
        },
        {
            field: 'updateId',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_UpdateId' && f.lanType === 'COL')[0].lanName
                    : '', //수정자
        },
    ];
    const [modalToggle, setModalToggle] = React.useState(false); //메뉴관리 팝업(왼쪽 그리드)
    const [modalToggle1, setModalToggle1] = React.useState(false); //권한관리 팝업(오른쪽 그리드)
    React.useEffect(() => {
        if (props.checkInputs.result) {
            gridRef.current.api.setRowData([
                {
                    lcategoCd: props.checkInputs.lcategoCd,
                    mcategoCd: props.checkInputs.mcategoCd,
                    scategoCd: props.checkInputs.scategoCd,
                    screenType: props.checkInputs.screenType,
                    newYn: 'Y',
                },
                ...props.rowData,
            ]);
            props.setCheckInputs({
                ...props.checkInputs,
                lcategoCd: '',
                mcategoCd: '',
                scategoCd: '',
                screenType: '',
                result: false,
            });
        }
    }, [props.checkInputs.result]);
    React.useEffect(() => {
        document.title = '메뉴관리';
        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '기초관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>메뉴관리</strong>" +
            '</h1>';
        if (props.checkInputs1.result) {
            gridRef1.current.api.setRowData([
                {
                    detailCd: props.checkInputs1.detailCd,
                    newYn: 'Y',
                },
                ...props.rowData1,
            ]);
            props.setCheckInputs1({
                ...props.checkInputs1,
                result: false,
            });
        }
    }, [props.checkInputs1.result]);
    return (
        <div className="card">
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                }}
            >
                <div style={{ width: '35%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                        }}
                    >
                        {/* 왼쪽 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10060"
                            target="G01"
                            refreshFunc={() => {
                                props.Init();
                            }}
                            selectFunc={() => props.Init()}
                            addFunc={() => setModalToggle(true)}
                            saveFunc={() => props.SaveConfirm()}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 왼쪽 그리드 */}
                        <AgGridReact
                            ref={gridRef}
                            animateRows={true}
                            columnDefs={columnDefs}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: false,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData}
                            rowSelection="single"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef, (_selected) => {
                                    if (_selected[0].lcategoCd) {
                                        props.setSelectedRowData(_selected);
                                        // props.setRowSelectData.push({
                                        //   lcategoCd: _selected[0].lcategoCd,
                                        //   scategoCd: _selected[0].scategoCd,
                                        //   mcategoCd: _selected[0].mcategoCd,
                                        //   screenType: _selected[0].screenType,
                                        // });
                                        props.GetMenusDtl(
                                            _selected[0].lcategoCd,
                                            _selected[0].scategoCd,
                                            _selected[0].mcategoCd,
                                            _selected[0].screenType
                                        );
                                    } else {
                                        props.setRowData1([]);
                                    }
                                })
                            }
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                            }
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                </div>
                <div style={{ width: '65%' }}>
                    <Section />
                    <Card
                        wrapStyle={{
                            display: 'flex',
                            justifyContent: 'space-between',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            {/* <BasicCombo
								combos={props.comboList}
								value={props.inputs.comboValue}
								onChange={(e) => {
									props.setInputs({
										...props.inputs,
										comboValue: e,
									});
								}}
							/> */}
                        </div>
                        {/* 오른쪽 그리드 버튼 */}
                        <AuthGroupButton
                            pageName="BM10060"
                            target="G02"
                            refreshFunc={() => props.AuthGroupCodeSearch(props.selectedRowData[0].lcategoCd)}
                            addFunc={() => {
                                setModalToggle1(true);
                            }}
                            saveFunc={() => props.SaveConfirm('grid1')}
                            //deleteFunc={() => props.DeleteConfirm("grid1")}
                        />
                    </Card>
                    <Section />
                    <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                        {/* 오른쪽 그리드  */}
                        <AgGridReact
                            ref={gridRef1}
                            animateRows={true}
                            columnDefs={columnDefs1}
                            defaultColDef={{
                                flex: 1,
                                minWidth: 100,
                                editable: true,
                                resizable: true,
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                            }}
                            rowData={props.rowData1}
                            rowSelection="multiple"
                            onSelectionChanged={() =>
                                GridFunctions.onSelectionChanged(gridRef1, props.setSelectedRowData1)
                            }
                            suppressRowClickSelection={true}
                            onCellValueChanged={(e) =>
                                GridFunctions.onCellValueChanged(e, gridRef1, props.setChangedRowData1)
                            }
                            groupDefaultExpanded={1}
                            suppressAggFuncInHeader={true}
                            enableCellChangeFlash={true}
                            getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                        />
                    </div>
                    {/* 메뉴관리 팝업  */}
                    {modalToggle && (
                        <BasicModal
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_MenuManagement' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : '' //메뉴관리
                            }
                            onClose={() => setModalToggle(false)}
                            buttonName1={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '' //검사
                            }
                            execLogic={() => props.CheckKeys()}
                        >
                            <Checking
                                datas={[
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_Lcategory' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //대분류
                                        value: props.checkInputs.lcategoCd,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                lcategoCd: e.target.value,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_Mcategory' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //중분류
                                        value: props.checkInputs.mcategoCd,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                mcategoCd: e.target.value,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_Scategory' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //소분류
                                        value: props.checkInputs.scategoCd,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                scategoCd: e.target.value,
                                            });
                                        },
                                    },
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_ScreenType' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //화면타입
                                        value: props.checkInputs.screenType,
                                        onChange: (e) => {
                                            props.setCheckInputs({
                                                ...props.checkInputs,
                                                screenType: e.target.value,
                                            });
                                        },
                                    },
                                ]}
                            />
                        </BasicModal>
                    )}
                    {/* 권한 팝업 */}
                    {modalToggle1 && (
                        <BasicModal
                            name={
                                props.lanData.length > 0
                                    ? props.lanData.filter(
                                          (f) => f.lanId === 'Dia_MenuManagement' && f.lanType === 'DIALOG'
                                      )[0].lanName
                                    : ''
                            }
                            onClose={() => setModalToggle1(false)}
                            buttonName1={
                                props.lanData.length > 0
                                    ? props.lanData.filter((f) => f.lanId === 'Btn_Check' && f.lanType === 'BTN')[0]
                                          .lanName
                                    : '' //검사
                            }
                            execLogic={() => props.CheckKeys1()}
                        >
                            <Checking
                                datas={[
                                    {
                                        name:
                                            props.lanData.length > 0
                                                ? props.lanData.filter(
                                                      (f) => f.lanId === 'Dia_FunctionCode' && f.lanType === 'DIALOG'
                                                  )[0].lanName
                                                : '', //기능코드
                                        value: props.checkInputs1.detailCd,
                                        onChange: (e) => {
                                            props.setCheckInputs1({
                                                ...props.checkInputs1,
                                                detailCd: e.target.value,
                                            });
                                        },
                                    },
                                ]}
                            />
                        </BasicModal>
                    )}
                </div>
            </div>
        </div>
    );
}

export default Bm10060;
